import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "http://localhost:8000";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

// Attach auth token to every request
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

/**
 * Update an applicant by ID.
 * Only sends fields supported by ApplicantUpdateSerializer:
 *   application, form_answers, cv, coverletter, extra_form_file, status
 */
export const updateApplicant = async (applicantId, data) => {
  const response = await apiClient.patch(
    `/api/applicants/${applicantId}/update/`,
    data
  );
  return response.data;
};

export default apiClient;
